import { render, staticRenderFns } from "./AnimalCalendar.vue?vue&type=template&id=05f0b0a8&"
import script from "./AnimalCalendar.vue?vue&type=script&lang=js&"
export * from "./AnimalCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AnimalCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports